import { Link, Route, Routes, useMatch } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

import usePageTitle from '@/hooks/use-page-title';
import { useAccident, useTiersAccidents } from '@/hooks/api/use-accidents';
import { useSelectedContract } from '@/hooks/api/use-contracts';
import { isACLContract } from '@/lib/contracts';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import ListeSinistres from '@/pages/accident/liste-sinistres';
import DeclarationSinistre from '@/pages/accident/declaration-sinistre';
import Sinistre from '@/pages/accident/sinistre';
import ConfirmationSinistre from '@/pages/accident/declaration-sinistre/confirmation-sinistre';

const Sinistres = () => {
    usePageTitle('Mes sinistres');

    const accidents = useTiersAccidents();
    const isACL = isACLContract(useSelectedContract());

    /* Sinistre ouvert, lu dans le cache de la fiche (le fil d'Ariane ne déclenche pas de lecture) */
    const match = useMatch('/mes-sinistres/contrat/:id/sinistre/:ids/*');
    const numCbt = useAccident(match?.params.id, match?.params.ids, false).data?.numCbt;

    const params = window.location.pathname.split('/');

    if (accidents.isPending) return <SmallSpinner />;

    return (
        <div className={'w-full'}>
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3.5 h-3.5" />
                <Link to="/mes-sinistres" className="hover:text-foreground transition-colors no-underline">Mes sinistres</Link>
                {params.length >= 5 && numCbt && (
                    <>
                        <ChevronRight className="w-3.5 h-3.5" />
                        <span className="text-foreground font-medium">Sinistre N°{numCbt}</span>
                    </>
                )}
            </nav>

            <h1 className="text-xl sm:text-2xl font-bold mt-4">Mes sinistres</h1>
            <div className="mt-4">
                <Routes>
                    <Route index element={<ListeSinistres/>} />
                    <Route path={'/contrat/:id/sinistre/:ids/*'} element={<Sinistre/>} />
                    { !isACL && <Route path={'/je-declare-un-sinistre'} element={<DeclarationSinistre/>} /> }
                    { !isACL && <Route path={'/je-declare-un-sinistre/vehicule/:vehiculeId'} element={<DeclarationSinistre/>} /> }
                    <Route path={'/je-declare-un-sinistre/rdv'} element={<ConfirmationSinistre/>} />
                </Routes>
            </div>
        </div>
    );
};

export default Sinistres;
